import {
  APIContextOptions,
  createAPIContext,
  createBloodSampleAPI,
  createBookingAPIv2,
  createConsentAPIv1,
  createConsentAPIv2,
  createEcgAPI,
  createNekoScopeAPI,
  createPatientAPI,
  createQuestionnaireAPI,
  createScanAPI,
  createScheduleAPI,
  createSiteAPI,
  createSiteCheckinSessionAPI,
  createUserAPI,
  createVisitAPI,
} from "@cur8/api-client";

export function createClient(options: APIContextOptions) {
  const context = createAPIContext(options);

  return {
    ecg: createEcgAPI(context),
    bloodSample: createBloodSampleAPI(context),
    booking: createBookingAPIv2(context),
    consent: createConsentAPIv1(context),
    consentV2: createConsentAPIv2(context),
    patient: createPatientAPI(context),
    scan: createScanAPI(context),
    schedule: createScheduleAPI(context),
    site: createSiteAPI(context),
    siteCheckinSession: createSiteCheckinSessionAPI(context),
    user: createUserAPI(context),
    visit: createVisitAPI(context),
    questionnaire: createQuestionnaireAPI(context),
    nekoScope: createNekoScopeAPI(context),
  };
}

export type APIClient = ReturnType<typeof createClient>;
